import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { ButtonHTMLAttributes } from "react";

type TChatFabProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  hasUnread?: boolean;
};

export function ChatFab({ hasUnread = false, className, ...props }: TChatFabProps) {
  return (
    <button
      type="button"
      aria-label="Open chat"
      data-testid="chat-fab"
      className={cn(
        "fixed bottom-4 right-4 z-40 size-[54px] text-innoveraZinc-900 drop-shadow-lg hover:text-innoveraZinc-800 transition-colors",
        className
      )}
      {...props}
    >
      <svg
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 size-full"
        aria-hidden="true"
      >
        <path
          d="M27 0C41.9117 0 54 12.0883 54 27C54 31.1806 53.0492 35.139 51.3528 38.6715C50.7779 39.8686 50.577 41.2257 50.9207 42.5085L53.1035 50.6543C53.5016 52.1412 52.1412 53.5016 50.6543 53.1035L42.5085 50.9207C41.2257 50.577 39.8686 50.7779 38.6715 51.3528C35.139 53.0492 31.1806 54 27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0Z"
          fill="currentColor"
        />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center">
        <InnoveraIcon width={27} height={27} className="[&>path]:fill-white" />
      </span>
      {hasUnread && <span className="absolute top-0 right-0 size-[14px] rounded-full bg-innoveraOrange-400" />}
    </button>
  );
}
